export default __webpack_public_path__ + "3c108ec9d137320a87df80cfeb8f0e65.png";